module.exports = "../images/fishing-lodge-3-3.jpg?v=edf80a8";